import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Separator } from 'telia-front-react';
import { useStores } from '../../stores/RootStore';
import { getReservationSlotTime } from '../../util/TimeUtil';
import { BranchType } from '../common/ReservationInterfaces';

const ReservationView = observer((): React.JSX.Element => {
  const {
    reservationStore: { reservation, findBranchById }
  } = useStores();
  const { translate } = React.useContext(TranslationsContext);

  const getHeaderText = (): string => {
    const branch = findBranchById(reservation.branchId);
    const parentBranch = findBranchById(branch.parentBranchId);
    const slotTime = getReservationSlotTime(reservation.slotNumber);

    const childStoreHeader = translate(`reservation.${branch.type === BranchType.TECH_STORE ? 'techStore' : 'b2bStore'}.administration.header`, {
      branchName: parentBranch ? parentBranch.name : branch.name,
      reservationDate: reservation.reservationDate,
      slotTime
    });
    const storeHeader = translate('reservation.store.administration.header', {
      branchName: branch.name,
      reservationDate: reservation.reservationDate,
      slotTime
    });

    return branch.type === BranchType.STORE ? storeHeader : childStoreHeader;
  };

  return (
    <>
      <p className="h4">{translate('reservation.store.administration.header.hello')}</p>
      <Separator spacing="small" color="invisible" />
      <p>{getHeaderText()}</p>
      <Separator spacing="xxsmall" color="invisible" />
    </>
  );
});

export default ReservationView;
